import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import { Icon } from "Components/UI";
import {
  BtnContainer,
  Container,
  Content,
  Title,
} from "./styles";

interface IIntegrationDiscipline {
  visible: boolean;
  active?: boolean;
  loading?: boolean;
  isDefault?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const IntegrationDiscipline: FC<IIntegrationDiscipline> = ({
  visible,
  active,
  loading,
  isDefault,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('editObra');
  const handleConfirm = () => {
    onConfirm();
    onCancel();
  }

  return (
    <Modal
      visible={visible}
      width={450}
      footerButtons={null}
    >
      <Container>
        <Title>
          <span className="textTitle">
            {active ? t('stagesPage.deactivateValidation') : t('stagesPage.activateValidation')}
          </span>
        </Title>

        <Content>
          <span className="contentText">
            {active
              ? t('stagesPage.integrationDeactivateText')
              : t('stagesPage.integrationActivateText')
            }
          </span>
          {!active && (
            <span className="warningBox">
              <Icon
                icon="alerta"
                customSize={16}
                className="alertIcon"
              />
              <span className="alertText">
                {t('stagesPage.integrationActivateWarning')}
              </span>
            </span>
          )}
        </Content>

        <BtnContainer>
          <Button type="text" className="cancelBtn" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          {!isDefault && (
            <Button
              type="primary"
              className="deleteBtn"
              onClick={handleConfirm}
              primaryDanger={active}
            >
              {loading && (
                <Spin
                  indicator={
                    <LoadingOutlined
                      color="white"
                      style={{ fontSize: 12, color: 'white', marginRight: 6 }}
                    />
                  }
                />
              )}
              {active && (loading ? t('common.deactivating') : t('common.deactivate'))}
              {!active && (loading ? t('common.activating') : t('common.activate'))}
            </Button>
          )}
        </BtnContainer>
      </Container>
    </Modal>
  )
}

export default IntegrationDiscipline;
